import React from 'react'
import { Typography, Divider, Row, Col } from 'antd';

function PriceHistoryTab(props: { property: any }) {
  const { property } = props;


  return (
    <Col>
      <Typography.Title level={5} style={{ marginTop: 0 }}>Price History</Typography.Title>

      {property?.priceHistory?.map((date: any) => (
        <Typography.Paragraph>{`Sold on ${date}`}</Typography.Paragraph>
      ))}

      <Typography.Title level={5}>Tax History</Typography.Title>
      <Row>
        <Col span={10}>
          <Typography.Paragraph>Date</Typography.Paragraph>
        </Col>
        <Col offset={2}>
          <Typography.Paragraph>Assessment</Typography.Paragraph>
        </Col>
      </Row>
      <Divider style={{ marginTop: 0 }} />

      <Col span={10}>
        {property?.taxHistory?.map((date: any) => (
          <Typography.Paragraph>{`${date}`}</Typography.Paragraph>
        ))}
      </Col>
      <Col offset={2}>
        {property?.assessmentHistory?.map((date: any) => (
          <Typography.Paragraph>{`${date}`}</Typography.Paragraph>
        ))}
      </Col>
    </Col>
  )
}

export default PriceHistoryTab